<div class="layout">
    <div class="layout-50 layout-left layout-flex">
        <app-sidebar-message></app-sidebar-message>
    </div>
    <div class="layout-50 layout-right layout-middle">
        <h1>{{ 'auth.signup.heading' | translate }}</h1>

        <div class="narrow">
            <div class="alert alert-error" *ngIf="error">
                {{ 'auth.signup.form.error' | translate }}
            </div>

            <app-auth-signup-form #form [model]="model" (submit)="onFormSubmitted(form)"></app-auth-signup-form>
        </div>
    </div>
</div>

